export default __webpack_public_path__ + "static/media/steamer.f75b0ad7.png";